<template>
    <a class="search-box mlztx" :class="className" @click="showFullArtwork($event, index)">
        <svg class="icon" aria-hidden="true">
            <use xlink:href="#icon-search"></use>
        </svg>
        <Audio v-if="hasAudios" v-bind:audioCont="artworkInfo.audioCont"> </Audio>
        <div class="full-view" v-if="showFull">
            <div class="full-artwork-box">
                <a :href="artworkInfo.link" target="_blank" :class="`full-artwork-linik imgPos${index}`">
                    <img v-lazy="artworkInfo.img" alt="" />

                    <div class="full-artwork-mess">
                        <div class="artwork-disc-chinese">
                            <p class="info" v-if="artworkInfo.words">"{{ artworkInfo.words }}</p>

                            <p class="info" v-if="artworkInfo.chinese">{{artworkInfo.chinese}}"</p>
                        </div>
                        
                        <p>《{{ artworkInfo.title }}》{{ artworkInfo.artist }} {{ artworkInfo.caizhi }} {{ artworkInfo.size }} {{ artworkInfo.year }}</p>
                    </div>
                    <!-- 字幕部分 -->
                    <div class="lyricWrapper-full" v-show="artworkInfo.lyric">
                        <div class="lyricContainer-full">
                            <p v-for="item in artworkInfo.lyric" :key="item.time" v-html="item.words"></p>
                        </div>
                    </div>
                </a>
            </div>

            <a href="javascript:;" class="close" @click.stop="close">
                ×
            </a>
        </div>
    </a>
</template>
<script>
import BufferAnimation from 'vue-scroll-buffer';
import Audio from './Audio';
import Drawer from './Drawer.vue';

export default {
    props: ['searchPosMess', 'anchorIndex', 'showFallMess', 'hasHandler', 'hasAudio'],
    components: {
        Audio,
        Drawer,
    },
    data() {
        return {
            className: this.searchPosMess,
            index: this.anchorIndex,
            showFull: false,
            artworkInfo: this.showFallMess,
            hasHandlers: this.hasHandler,
            hasAudios: this.hasAudio,
            Subtitle: null,
            rootEle: '', //放大镜对应的父级跟元素
            rootEleHeight: '', //放大镜对应的父级跟元素的offsetTop
            parentHeight: 0, //放大镜对应的父元素的高度
            appScrollTop: 0, //页面的滚动高度
            clientHeight: 0, //// 获取浏览器可视区域高度
            centerDistence: 0,
            currentDistence: 0,
            distance: 0,
            top: 0,
        };
    },

    methods: {
        showFullArtwork(e, idx) {
            this.Subtitle = document.getElementsByClassName('lyricContainer-full');
            let that = this;
            if (this.hasHandlers) {
                this.showFull = true;
            }

            //监听到语音播放完毕后恢复斜杠状态
            if (this.hasAudios) {
                let currentAudio = e.currentTarget.getElementsByTagName('audio');
                currentAudio[0].addEventListener(
                    'ended',
                    function() {
                        that.$emit('playBackgroundMusic');
                    },
                    false
                );
                // 语音同步字幕
                currentAudio[0].addEventListener('timeupdate', function() {
                    // 将上次播放的高度清0
                    if (that.Subtitle[0]) {
                        that.Subtitle[0].style.top = 0;
                    }
                    // 显示字幕区域
                    that.switchBannerHide = true;

                    let _this = this;
                    if (!that.artworkInfo.lyric) return;
                    for (let i = 0; i < that.artworkInfo.lyric.length; i++) {
                        //比对时间
                        if (this.currentTime > that.artworkInfo.lyric[i].time - 0.5) {
                            // 获取每个字幕的高度
                            let h = document.getElementsByClassName('lyricWrapper-full')[0].clientHeight;
                           
                            // 设置字幕区域的top
                            if (that.Subtitle[0]) {
                                that.Subtitle[0].style.top = -(h * i) + 'px';
                            }
                        }
                    }
                });
            }
        },
        close() {
            this.showFull = false;
        },
    },
};
</script>
<style>
.full-artwork-mess .artwork-disc::-webkit-scrollbar ,.artwork-disc-chinese::-webkit-scrollbar {
    width: 5px;  
    height: 0px; 
}
.full-artwork-mess .artwork-disc::-webkit-scrollbar-thumb ,.artwork-disc-chinese::-webkit-scrollbar-thumb {
    border-radius: 6px;
    -webkit-box-shadow: inset 0 0 5px rgba(255,255,255,0.9);
    background: rgba(255,255,255,0.1);
}
.full-artwork-mess .artwork-disc::-webkit-scrollbar-track  ,.artwork-disc-chinese::-webkit-scrollbar-track  {
    -webkit-box-shadow: inset 0 0 5px rgba(255,255,255,0.1);
    border-radius: 6px;
    background: rgba(255,255,255,0.5);

}
.mlztx { 
    -webkit-box-shadow: 0px 0px 15px 20px hsla(0, 0%, 0%, 0.1);
    box-shadow: 0px 0px 15px 20px hsla(0, 0%, 0%, 0.1);
    
    text-align: center;
    
    color: #fff;
    transition: all 4s ease 1s;
    animation: ripple 1.6s linear infinite;
  }
  @keyframes ripple {
    0% {
      box-shadow: 0 0 0 0 rgba(237,245,26, 0.9)
      /*,
        0 0 0 10px rgba(93, 190, 219, 0.2), 0 0 0 20px rgba(93, 190, 219, 0.2),
        0 0 0 30px rgba(93, 190, 219, 0.2);*/
    }
    100% {
      box-shadow: 0 0 0 15px rgba(237,245,26, 0.1)/*,
        0 0 0 20px rgba(93, 190, 219, 0.2), 0 0 0 30px rgba(93, 190, 219, 0.2),
        0 0 0 40px rgba(93, 190, 219, 0);*/
    }
  }
.search-box {
    display: block;
    width: 0.2rem;
    height: 0.2rem;
    background: #fff;
    border-radius: 100%;
    text-align: center;
    line-height: 0.22rem;
    position: absolute;
    left: 29%;
    top: 39%;
}
.search-box .icon {
    color: #555555;
    width: 0.13rem;
    height: 0.13rem;
    position: absolute;
    left: 19%;
    top: 19%;
}
.full-view {
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.8);
    z-index: 11111;
}
.artwork-disc-chinese{
    margin-bottom:0.1rem;
}
.full-artwork-link {
    display: block;
}

.full-artwork-box {
    width: 100%;
    height: 100%;
    position: relative;
}
.full-artwork-linik {
    position: absolute;
    left: 25%;
    top: 10%;
    width: 50%;
    height: 100%;
}
.full-artwork-linik img {
    max-width: 99%;
    max-height: 50%;
}
.full-artwork-mess .artwork-disc-chinese {
    overflow: auto;
    max-height: 0.4rem;
    margin-top:10px;
}
.full-artwork-mess p{
    color: #fff;
    font-size: 15px;
    line-height: 0.12rem;
}
.full-view .close {
    position: absolute;
    right: 10%;
    top: 4%;
    z-index: 11111111111;
    font-size: 0.2rem;
    color: #fff;
    font-weight: bold;
}
.lyricContainer-full p {
    color: #fff;
    font-size: 15px;
}
.lyricWrapper-full {
    height: 0.43rem;
    overflow: hidden;
    width: 95%;
    background: rgba(255, 255, 255, 0.3);
    margin: 0 auto;
    border-radius: 2em;
}
.lyricContainer-full {
    position: relative;
}
.searchPos10-1 .lyricWrapper,
.searchPos10 .lyricWrapper {
    display: none;
}
</style>
